import { fromJS } from 'immutable';
import {
  CHANGE_CLIENT_TABLE_SEARCH,
  TOGGLE_CLIENT_FORM,
  TOGGLE_CLIENT_VIEW,
  TOGGLE_CLIENT_INVITATION_FORM,
  TOGGLE_LEGAL_ENTITY_FORM,
  TOGGLE_USER_CLIENT_FORM,
  LOAD_CLIENTS_TABLE_SUCCESS,
  UPDATE_CLIENT_SUCCESS,
} from 'constants/ActionTypes';

const initialState = fromJS({
  search: null,
  dataset: [],
  pagination: {
    totalCount: null,
    pageCount: null,
    currentPage: null,
    perPage: null,
  },
  form: {
    isVisible: false,
    clientId: null,
    data: null,
  },
  view: {
    isVisible: false,
    clientId: null,
  },
});

const clientTableReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOAD_CLIENTS_TABLE_SUCCESS:
      return state.merge(
        fromJS({
          dataset: action.clients.items.map((client) => client.companyId),
          pagination: {
            totalCount: action.clients._meta.totalCount,
            pageCount: action.clients._meta.pageCount,
            currentPage: action.clients._meta.currentPage,
            perPage: action.clients._meta.perPage,
          },
        }),
      );
    case TOGGLE_CLIENT_INVITATION_FORM:
      return state.setIn(['view', 'isVisible'], !state.getIn(['view', 'isVisible']));
    case TOGGLE_USER_CLIENT_FORM:
      return state.setIn(['view', 'isVisible'], !state.getIn(['view', 'isVisible']));
    case TOGGLE_LEGAL_ENTITY_FORM:
      if (state.getIn(['view', 'clientId'])) {
        return state.setIn(['view', 'isVisible'], !state.getIn(['view', 'isVisible']));
      }
      return state;
    case TOGGLE_CLIENT_VIEW:
      return state.set(
        'view',
        fromJS({
          isVisible: !state.getIn(['view', 'isVisible']),
          clientId: action.clientId,
        }),
      );
    case CHANGE_CLIENT_TABLE_SEARCH:
      return state.set('search', action.search);
    case TOGGLE_CLIENT_FORM:
      if (state.getIn(['form', 'isVisible'])) {
        return state.merge(
          fromJS({
            form: {
              isVisible: false,
              clientId: null,
              data: null,
            },
          }),
        );
      } else {
        return state.merge(
          fromJS({
            form: {
              isVisible: true,
              clientId: action.clientId,
              data: action.data,
            },
          }),
        );
      }
    case UPDATE_CLIENT_SUCCESS:
      if (state.get('dataset').includes(action.client.companyId)) {
        return state;
      }
      return state.set('dataset', state.get('dataset').unshift(action.client.companyId));
    default:
      return state;
  }
};

export default clientTableReducer;
